import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useMst } from '../../store/store';
import Swal from 'sweetalert2';
import Tab from 'react-bootstrap/Tab';
// import { poolsApi } from '../../services/api';
import Tabs from 'react-bootstrap/Tabs';
import LPStaking from './lpStaking';

import './PageStaking.scss';

const PageStaking: React.FC = observer(() => {
  const { user } = useMst();
  const [SMApproveflexAmount, setSMApproveFlexAmount] = useState('0');
  const [SMStakeflexAmount, setSMStakeFlexAmount] = useState('0');
  const [SMTokenAmount, setSMTokenAmount] = useState('0');
  const [SMApproveAmount, setSMApproveAmount] = useState('0');
  const [userStakeData, setUserStakeData] = useState<obj[]>([]);

  interface obj {
    stakeTime: any;
    stakeAmount: any;
    unStakeTime: any;
    rewards: any;
    stakeid: any;
    Action: any;
  }

  // const staking_address = "TMvmPZEfDmit7cUNk5TQv5PpxvSFfCfT3f";
  // const token_address = "TRXuDwR9EYWwindMPx8yveAcaDTR3Z3XXz";

  const staking_address = "TK3DP8Q4W2LC1naUmuLD5gu3idtnVrnQZP";
  const token_address = "TT4y3TzafQi1LcZ1AU8rpXBmDxhACK6QYe";

  

  const SMApprove = async () => {
    const Useramt = SMApproveflexAmount;
    if (Number(Useramt) > 0) {
      const token_instance = await window.tronWeb.contract().at(token_address);
      const balance = await token_instance.methods.balanceOf(user.address).call();
      const balance1 = window.tronWeb.toDecimal(balance);
      if (balance1 !== 0) {
        const token_approve = await token_instance.approve(staking_address, Number(SMApproveflexAmount) * 10 ** 8).send({ from: user.address, feeLimit: 1000 * 10 ** 6 });
        Swal.fire({ title: "<h5 style='color:white'>Your Transaction is sent for Confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
        setTimeout(async function () {
          const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(token_approve);
          // window.test = event.ret;
          console.log("D", event.receipt.result)
          // console.log(event.ret[0].contractRet)
          if (event.receipt.result === 'SUCCESS') {
            setSMApproveFlexAmount("0")
            Swal.fire({ title: "<h5 style='color:white'>Transaction Confirm.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
            const allowance = await token_instance.methods.allowance(user.address, staking_address).call();
            const allowancebal = window.tronWeb.toDecimal(allowance);
            const approvebal = (allowancebal / 10 ** 8).toString();
            setSMTokenAmount(approvebal);
            // $('#hideamt').val('0');
          } else {
            Swal.fire({ title: "<h5 style='color:white'>Transaction Error.</h5>", icon: "error", background: "#808080", showConfirmButton: false, timer: 4000 });
          }
        }, 6000)
      } else {
        Swal.fire({ title: "<h5 style='color:white'>Not enough balance in your wallet</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 4000 });
      }
    } else {
      Swal.fire({ title: "<h5 style='color:white'>Please enter the valid amount.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 4000 });
    }
  }

  const SMStake = async () => {
    const Useramt = SMStakeflexAmount;
    if (Number(Useramt) > 0) {
      const token_instance1 = await window.tronWeb.contract().at(token_address);
      const allowance = await token_instance1.methods.allowance(user.address, staking_address).call();
      const allowancebal = window.tronWeb.toDecimal(allowance);
      // console.log(allowancebal, "helloo")
      if (allowancebal !== 0) {
        // console.log(allowancebal / 10 ** 8, typeof (Number((Useramt))));
        if (Number(Useramt) <= allowancebal / 10 ** 8) {
          const token_instance = await window.tronWeb.contract().at(staking_address);
          const token_approve = await token_instance.stake(Number(SMStakeflexAmount) * 10 ** 8).send({ from: user.address, feeLimit: 1000 * 10 ** 6 });
          Swal.fire({ title: "<h5 style='color:white'>Your Transaction is sent for Confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });

          setTimeout(async function () {
            const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(token_approve)
            if (event.receipt.result === 'SUCCESS') {
              setSMStakeFlexAmount("0")
              Swal.fire({ title: "<h5 style='color:white'>Transaction Confirm.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
              // if (allowancebal === 0) {
              //   $('#approve').hide();
              // }
              // else {
              //   $('#approve').show();
              // }
              // getstakeDetails();
              // $("#unstake").show();
              // $("#harvest").show();
              // $('#hideamt').html('0');

            }

          }, 4000)
        } else {
          Swal.fire({ title: "<h5 style='color:white'>You have not enough approved tokens.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 4000 });
        }
      } else {
        Swal.fire({ title: "<h5 style='color:white'>Your tokens have not approved.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 4000 });
      }
    } else {
      Swal.fire({ title: "<h5 style='color:white'>Please enter the valid amount.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 4000 });
    }
  }

  const unstake = async (id : any, unStakeTime : any) => {
    const token_instance = await window.tronWeb.contract().at(staking_address);

    if (Math.floor(Date.now() / 1000) > unStakeTime) {
      const token_approve = await token_instance.unstake(id).send({ from: user.address, feeLimit: 1000 * 10 ** 6 });
      Swal.fire({ title: "<h5 style='color:white'>Your Transaction is sent for Confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
      setTimeout(async function () {
        const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(token_approve)
        if (event.receipt.result === 'SUCCESS') {
          Swal.fire({ title: "<h5 style='color:white'>Transaction Confirm.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
          // getstakeDetails();
        }

      }, 9000)
    } else {
      Swal.fire({ title: "<h5 style='color:white'>You are in lock-period.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 4000 });
    }
  }

  const harvest = async (id : any) => {
    const token_instance = await window.tronWeb.contract().at(staking_address);
    const token_approve = await token_instance.harvest(id).send({ from: user.address, feeLimit: 1000 * 10 ** 6 });
    Swal.fire({ title: "<h5 style='color:white'>Your Transaction is sent for Confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
    setTimeout(async function () {
      const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(token_approve)
      if (event.receipt.result === 'SUCCESS') {
        Swal.fire({ title: "<h5 style='color:white'>Transaction Confirm.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
        // console.log(event.receipt.result)
        // getstakeDetails();
      }
      else {
        Swal.fire({ title: "<h5 style='color:white'>Transaction Error.</h5>", icon: "error", background: "#808080", showConfirmButton: false, timer: 4000 });
      }
    }, 4000)
  }



  useEffect(() => {

    const data: any[] = [];

    const userstackDetails = async (token_instance : any, i :any) => {
      /* eslint-disable no-unused-vars */
      return new Promise((resolve) => {
        const obj = {
          stakeTime: '',
          stakeAmount: '',
          unStakeTime: '',
          rewards: '',
          stakeid: '',
        };
        token_instance.methods.stakeDetails(user.address, i).call().then((stake_details) => {
          const stakeTime = window.tronWeb.toDecimal(stake_details.stackTime);
          const stakeAmount = window.tronWeb.toDecimal(stake_details.amount);
          const unStakeTime = window.tronWeb.toDecimal(stake_details.unStakeTime);
          token_instance.methods.getCurrentReward(user.address, i).call().then((reward : any) => {
            const Rewards = window.tronWeb.toDecimal(reward);

            obj.stakeTime = stakeTime;
            obj.stakeAmount = stakeAmount;
            obj.unStakeTime = unStakeTime;
            obj.rewards = Rewards;
            obj.stakeid = i;
            resolve(data.push(obj));
          });

        });
      })

    }

    const getstakeDetails = async () => {
      const token_instance = await window.tronWeb.contract().at(staking_address);
      const len = await token_instance.methods.getStakeLength(user.address).call();
      const len1 = window.tronWeb.toDecimal(len);
      let i = 0;
      /* eslint-disable no-await-in-loop */
      while (i < len1) {
        await userstackDetails(token_instance, i);
        i += 1;
      }

      setUserStakeData(data);
    }

    const refresh = async () => {
      const token_instance = await window.tronWeb.contract().at(token_address);
      const bal = await token_instance.methods.balanceOf(user.address).call();
      const bal1 = ((await window.tronWeb.toDecimal(bal)) / 10 ** 8).toString();
      const allowance = await token_instance.methods.allowance(user.address, staking_address).call();
      const allowancebal = window.tronWeb.toDecimal(allowance);
      const approvebal = allowancebal / 10 ** 8;
      setSMTokenAmount(bal1);
      setSMApproveAmount(approvebal.toString());
    }

    if (user.address) {
      getstakeDetails();
      refresh();
    }
  }, [user.address]);

  return (
    <>
      <section className="page-pool">
        <div className="page-pool__container">
          <div className="page-pool__container__tabs">
            <Link className="page-pool__container__tabs__tab" to="/">
              Swap
            </Link>
            <Link className="page-pool__container__tabs__tab" to="/pools">
              LIQUIDITY
            </Link>
            <div className="page-pool__container__tabs__tab active">Staking</div>
          </div>
        </div>
      </section>

      <section className='w-100 mt-2 staking'>
        <div className='container-fluid w-100' >
          <div className="row section2">
            <div>
              <Tabs
                defaultActiveKey="profile"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="profile" title="SM Token">
                  <div className='staking__tabs' >
                    <div className='text-center'>
                      <h3>Staking </h3>
                      <p >Token Balance: <span id="tokenbalance">{SMTokenAmount}</span> SM</p>
                      <p >Approve Balance: <span id="approvebalance">{SMApproveAmount}</span> SM</p>
                    </div>
                    <div className='staking_amount mb-4 mt-2 d-flex justify-content-center' style={{ alignItems: "center", gap: "20px" }}>
                      <div className='text-center' style={{ width: "100%", border: "1px solid #fff", padding: "20px 25px 0", borderRadius: "15px" }}>

                        <p  >Enter amount (SM):-</p>
                        <input className='form-input' type="text" onChange={(e) => { setSMApproveFlexAmount(e.target.value) }} name='username' placeholder='Enter your Amount' value={SMApproveflexAmount} id="hideamt" />
                        <span id="amt_err" />
                        <div className='text-center' style={{ display: 'flex', justifyContent: 'center' }}>
                          <button className="liquidity-set__create yellow-btn" type='button' id="approve" onClick={SMApprove}>Approve</button>
                        </div>

                      </div>

                      <div id="hidetextstake" style={{ border: "1px solid #e5ac4b", padding: "20px 25px 0", borderRadius: "15px" }}>
                        <p>Enter amount (SM):-</p>
                        <input className='form-input' type="text" onChange={(e) => { setSMStakeFlexAmount(e.target.value) }} name='username' placeholder='Enter your Amount' value={SMStakeflexAmount} id="hideamt1" />
                        <span id="amt_err" />
                        <button className="liquidity-set__create yellow-btn" type='button' id="stake" onClick={SMStake}>Stake</button>
                        {/* <button className="liquidity-set__create yellow-btn" type='button' id="stake" style={{display:"none"}} onClick={stake}>Stake</button> */}
                      </div>
                    </div>

                    <div className='staking_table'>
                      <h3 style={{ textAlign: 'center' }}>Your stats</h3>
                      <div className='tabless' style={{ overflow: "scroll", maxHeight: "400px" }}>
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">StakeAmount</th>
                              <th scope="col">StakeTime</th>
                              <th scope="col">UnstakeTime</th>
                              <th scope="col">Pool</th>
                              <th scope="col">Rewards</th>
                              <th scope="col" style={{ textAlign: "center" }}>Unstake</th>
                              <th scope="col" style={{ textAlign: "center" }}>Claim</th>
                            </tr>
                          </thead>
                          <tbody id="received">
                            {
                              userStakeData.length > 0 ?userStakeData.map((item) => {
                                return (
                                  <tr key={item.stakeTime}>
                                    <td>{((item.stakeAmount) / 10 ** 8)} SM</td>
                                    <td>{new Date(item.stakeTime * 1000).toLocaleString()}</td>
                                    <td>{new Date(item.unStakeTime * 1000).toLocaleString()}</td>
                                    <td>{(item.rewards / 10 ** 8)} SM</td>
                                    <td><button className="liquidity-set__create yellow-btn" type='button' id="unstake" onClick={() => unstake(item.stakeid, item.unStakeTime)}>Unstack</button></td>
                                    <td><button className="liquidity-set__create yellow-btn" type='button' id="harvest" onClick={() => harvest(item.stakeid)}>claim</button></td>
                                  </tr>
                                )
                              }): <tr><td colSpan={5}>No Stake Details Found.</td></tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="home" title="LP Staking"><LPStaking /></Tab>


              </Tabs>
            </div>

          </div>
        </div>
      </section>
    </>
  );
});

export default PageStaking;
